import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { WORKSPACES, WORKSPACE_DEFAULTS } from '../routes/workspaces';

export const useWorkspaceStore = create(
  persist(
    (set, get) => ({
      activeWorkspace: WORKSPACES.PUBLIC,
      lastVisitedByWorkspace: {
        [WORKSPACES.PUBLIC]: WORKSPACE_DEFAULTS[WORKSPACES.PUBLIC],
      },

      setWorkspace: (workspace) => set({ activeWorkspace: workspace }),

      setLastVisited: (workspace, path) =>
        set((state) => ({
          lastVisitedByWorkspace: {
            ...state.lastVisitedByWorkspace,
            [workspace]: path,
          },
        })),

      getTargetRoute: (workspace) => {
        const state = get();
        return state.lastVisitedByWorkspace[workspace] || WORKSPACE_DEFAULTS[workspace];
      },
    }),
    {
      name: 'workspace-storage',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        activeWorkspace: state.activeWorkspace,
        lastVisitedByWorkspace: state.lastVisitedByWorkspace,
      }),
    }
  )
);
